import leads from './leads';
import unities from './unities';
export default {
    leads,
    unities
};